export default __webpack_public_path__ + "static/media/icon_nav_back.6026202f.svg";